module.exports = {
          srcSet: __webpack_public_path__ + "8e2fd9cbd4a2a6589cee382ee64dc397-160.png"+" 160w",
          images:[ {path: __webpack_public_path__ + "8e2fd9cbd4a2a6589cee382ee64dc397-160.png",width: 160,height: 160}],
          src: __webpack_public_path__ + "8e2fd9cbd4a2a6589cee382ee64dc397-160.png",
          toString:function(){return __webpack_public_path__ + "8e2fd9cbd4a2a6589cee382ee64dc397-160.png"},
          
          width: 160,
          height: 160
        }